import angular from 'angular';
import { RealEstateSearchResultComponent } from './real-estate-search-result.component';

import searchService from './../../search/search.module';
import niceUrlService from './../../niceUrl/nice-url.module';

import realEstateSearchResultList from './../real-estate-search-result-list/real-estate-search-result-list.module';
import realEstateSearchResultMap from './../real-estate-search-result-map/real-estate-search-result-map.module';
import advancedSearch from './../advanced-search/advanced-search.module';
import propertySearchBar from '../../home/property-search-bar/property-search-bar';
import realEstateGallery from './../../real-estate/real-estate-gallery/real-estate-gallery.module';
import loanTable from './../../loan/loan-table/loan-table.module';
import realEstateSearchResultListWithLoan from './../real-estate-search-result-list-with-loan/real-estate-search-result-list-with-loan.module';
import WebWalk from './../../webwalk-util/webwalk.module';
import saveSearch from '../../save-search/save-search.module';
export const realEstateSearchResultModule = angular
	.module('realEstateSearchResult', [
		realEstateSearchResultListWithLoan,
		loanTable,
		searchService,
		niceUrlService,
		realEstateSearchResultList,
		realEstateSearchResultMap,
		advancedSearch,
		propertySearchBar,
		realEstateGallery,
		WebWalk,
		saveSearch
	])
	.component('realEstateSearchResult', RealEstateSearchResultComponent).name;
